import {
    Card,
    Text,
    Heading,
    Box,
    SimpleGrid,
    Stack,
    Divider,
    AbsoluteCenter,
    CardHeader,
} from "@chakra-ui/react";
import styled from "@emotion/styled";

const ScriptedText = styled(Text)`
    font-family:"Satisfy", cursive;
`

function Entourage() {

    return (
        <div>
            <Card
                backgroundColor="#FEEFEC"
                shadow='xl'
                margin={8}
                padding={4}>
                <CardHeader>
                    <Box textAlign="center">
                        <Heading style={{
                            fontFamily: '"Satisfy", cursive'
                        }} size="lg">
                            The Entourage
                        </Heading>
                    </Box>
                </CardHeader>
                <SimpleGrid margin={3} columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Groom
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Val Anthony Garay
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Bride
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Justine Cara Mondia
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>

                {/* Parents */}
                <SimpleGrid margin={3} columns={{ base: 1, md: 1, }} spacing={2} alignContent='center' justifyContent="center">
                    <Box position='relative' p='2'>
                        <Divider borderWidth='2px' />
                        <AbsoluteCenter bgColor="#FEEFEC" px='4'>
                            <ScriptedText as='b' fontSize='xl'>
                                Parents
                            </ScriptedText>
                        </AbsoluteCenter>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText fontSize='l'>
                                Valeriano Garay
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Ma. Elfa Garay
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText fontSize='l'>
                                Carlos Mondia
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Barbara Pat Mondia
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>

                {/* Principal Sponsors */}

                <SimpleGrid margin={4} columns={{ base: 1, md: 1, }} spacing={2} alignContent='center' justifyContent="center">
                    <Box position='relative' p='2'>
                        <Divider borderWidth='2px' />
                        <AbsoluteCenter bgColor="#FEEFEC" px='4'>
                            <ScriptedText as='b' fontSize='xl'>
                                Principal Sponsors
                            </ScriptedText>
                        </AbsoluteCenter>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText fontSize='l'>
                                Eugenio Alegada
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Francis Balinas
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Engr. Jesus Dato-on
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Ramon Singson
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Dr. Martin Samuel Torres
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Lauro Mondia
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText fontSize='l'>
                                Lourdes Madriaga
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Dr. Rhona Balinas
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Ma. Luisa Dato-on
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Deborah Natalia Singson
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Sandra Locsin
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Ma. Corazon Mondia
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>

                {/* Secondary Sponsors */}
                <SimpleGrid margin={5} columns={{ base: 1, md: 1, }} spacing={2} alignContent='center' justifyContent="center">
                    <Box position='relative' p='2'>
                        <Divider borderWidth='2px' />
                        <AbsoluteCenter bgColor="#FEEFEC" px='4'>
                            <ScriptedText as='b' fontSize='xl'>
                                Secondary Sponsors
                            </ScriptedText>
                        </AbsoluteCenter>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Candles
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Clint Joseph Tan
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Karysa Janel Tan
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Chord
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Engr. Benjo Rey Ilisan
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Valerie Joy Garay
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns={{ base: 1, md: 1, }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Veil
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Earl Ayson
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Dr. Pearl Joy Ayson
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>

                {/* Others */}
                <SimpleGrid marginTop={2} columns={{ base: 1, md: 1, lg: 1 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Matron of Honor
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Dr. Ma. Jesilou Dato-on - Demonteverde
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Bestman
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Engr. Blaire Demonteverde
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Maid of Honor
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Dr. Elaine Valeriano
                            </ScriptedText>
                        </Stack>
                    </Box>

                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Groomsmen
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Sean Xavier Labayen
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Kenn Tabacug
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Engr. East Tristan Encabo
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Engr. Jezmar Lee Nueva Ecija
                            </ScriptedText>

                        </Stack>

                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Bridesmaids
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Jella R. Bantolinao
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Ritz Lindsy Pesca
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Kaisha Balboa - Rodrigo
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Antonietta Javellana
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>
                <SimpleGrid marginTop={2} columns={{ base: 1, md: 1, lg: 1 }} spacing={2} alignContent='center' justifyContent="center">
                </SimpleGrid>
                <Box textAlign="center">
                    <Stack direction="column">
                        <ScriptedText as='b' fontSize='xl'>
                            Ring Bearer
                        </ScriptedText>
                        <ScriptedText fontSize='l'>
                            Calix Kai Tan
                        </ScriptedText>
                    </Stack>
                </Box>
                <SimpleGrid marginTop={2} columns={{ base: 1, md: 1, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">

                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Bible Bearer
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Jhess Nikkolas Gedoria
                            </ScriptedText>
                        </Stack>
                    </Box>
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Coin Bearer
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Paul Yzekiel Ayson
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>
                <SimpleGrid marginTop={2} columns={{ base: 1, md: 1, }} spacing={2} alignContent='center' justifyContent="center">
                    <Box textAlign="center">
                        <Stack direction="column">
                            <ScriptedText as='b' fontSize='xl'>
                                Flower Girls
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Princess Margaux Ayson
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Precious Ymara Ayson
                            </ScriptedText>
                            <ScriptedText fontSize='l'>
                                Maxinne Joyce Ayson
                            </ScriptedText>
                        </Stack>
                    </Box>
                </SimpleGrid>
            </Card>
        </div >

    );
}

export default Entourage;

